function parents(node: Element, ps: Element[]): Element[] {
    if(!node || node?.parentElement === null) { return ps; }

    return parents(node.parentElement, ps.concat([node]));
}

const style = (node: Element, prop: string) => {
    return getComputedStyle(node, null).getPropertyValue(prop);
};

const overflow = (node: Element) => {
    return style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x');
};

const scroll = (node: Element) => {
    return /(auto|scroll)/.test(overflow(node));
};

export default function getScrollParent (node: Element): Element {
    if(!(node instanceof HTMLElement || node instanceof SVGElement)) {
        return null;
    }

    const ps = parents(node.parentElement, []);

    for (let i = 0; i < ps.length; i += 1) {
        if(scroll(ps[i])) {
            return ps[i];
        }
    }

    return document.scrollingElement || document.documentElement;
}
